import { render, staticRenderFns } from "./PdfQuestion.vue?vue&type=template&id=90984b64"
import script from "./PdfQuestion.vue?vue&type=script&lang=js"
export * from "./PdfQuestion.vue?vue&type=script&lang=js"
import style0 from "./PdfQuestion.vue?vue&type=style&index=0&id=90984b64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports